import { createAction } from '@reduxjs/toolkit';
import ClientsAction from 'types/clients/enums/Clients';

const cleanSelectedClients = createAction(ClientsAction.CLEAN_SELECTED_CLIENT);

export default cleanSelectedClients;
